export default __webpack_public_path__ + "833c66a2dd87623c60181c04b0e2ceed.svg";